module.exports = __webpack_public_path__ + "img/image10.a9b09f31.png";